import React, { useEffect, useState } from "react";
import { useStores } from "../../../store";
import { name } from "../../../services/white_label";
import { useObserver } from "mobx-react";

const NotificationSettingComponent = ({
  title,
  description,
  onChange,
  Enabled,
}) => {
  const { UserStore } = useStores();
  const [isEnabled, setIsEnabled] = useState(Enabled);

  useEffect(() => {
    setIsEnabled(Enabled);
  }, [Enabled]);

  const handleToggle = async () => {
    try {
      const res = await UserStore.UpdateUserStatus({
        additionalSettings: [
          {
            name: "emailNotifications",
            value: !isEnabled,
          },
        ],
      });

      if (res) {
        setIsEnabled(!isEnabled);
      }
    } catch (error) {
      console.error("Error toggling notification:", error);
    }
  };

  return useObserver(() => (
    <div className="rounded-lg md:p-5 lg:p-5 p-5 bg-[#f4f4f4] md:w-full lg:w-full w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl mx-auto md:mb-5 lg:mb-5 mb-0">
      <div className="flex items-center justify-between">
        <h1 className="md:font-bold lg:font-bold font-semibold text-base md:text-xl lg:text-xl">
          {title}
        </h1>
        <button
          onClick={handleToggle}
          className={`w-10 h-5 flex p-0 items-center rounded-full transition-colors duration-300 ${
            isEnabled ? "bg-orange-500" : "bg-gray-300"
          }`}
        >
          <div
            className={`w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
              isEnabled ? "translate-x-5" : "translate-x-0"
            }`}
          ></div>
        </button>
      </div>
      <p className="mt-2 text-gray-500 text-sm md:text-base">{description}</p>
    </div>
  ));
};

export default NotificationSettingComponent;

